// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__28hOh","label":"Category_label__3nxTa","content":"Category_content__2BHhI","header":"Category_header__XMzZp","location":"Category_location__2R5IV"};